<template>
  <div class="loyalty-benefits-icons-container container">
    <div class="loyalty-benefits-icons">
      <div v-for="(value, key) in items" :key="key" class="icon icon-container">
        <i :class="`icon icon-${key}`" />
        <p>{{ value }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BenefitIcons",
  props: {
    items: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.loyalty-benefits-icons {
  display: flex;
  justify-content: center;
  font-size: 20px;
  margin-bottom: 50px;

  @include respond-above(md) {
    margin: 0 auto 140px;
  }
}

.icon-container {
  text-align: center;
  flex: 0 1 150px;

  p {
    font-family: $utility-font-family;
    font-size: 13px;
    font-weight: 400;
    margin: 10px 10px;
  }
}
</style>
